import { render } from "./AddedSetToBag.vue?vue&type=template&id=19a08d8d&scoped=true"
import script from "./AddedSetToBag.vue?vue&type=script&lang=js"
export * from "./AddedSetToBag.vue?vue&type=script&lang=js"

import "./AddedSetToBag.vue?vue&type=style&index=0&id=19a08d8d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a08d8d"]])

export default __exports__